export default "__VITE_ASSET__Dg_KzR6x__"